import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { styled } from "@mui/material/styles";
import IDSTable from "./IDSTable";
import Button from "react-bootstrap/Button";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ERROR_MSG } from "../services/Constants";
import { S3_URL } from "../services/Constants";
import {
  Checkbox,
  FormGroup,
  FormControlLabel,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { FixedSizeList } from "react-window";
import Alert from "react-bootstrap/Alert";
import {
  fetchTransactionById,
  fetchTransactionHL7,
  removeTransactionRecord,
  updateTransactionRecord,
  reprocessBulkTransactionRecord,
  fetchDuplicateTransaction,
  fetchTransactionJSON,
  updateTransactionFields,
  reprocessBulkEicrTransactionRecord,
} from "../services/errorMessageQueue-service";
import moment from "moment";
import { errorMessageHeadCells } from "../util/headcells-util";
import FullScreenSpinner from "./FullScreenSpinner";
import ErrorMessageQAFlags from "./ErrorMessageQAFlags";
import ErrorMessageJSONTab from "./ErrorMessageJSONTab";
import { useContext } from "react";
import UserContext from "../context/user-context";
import { componentIsVisible, validateAndSanitizeUrl } from "../util/common";
import { UFDDB, EMDDB } from "../util/component-codes";
import { fetchCodeSetTable } from "../services/referenceTable-service";
import Cookies from "js-cookie";
import _ from "lodash";
import { fetchConditions } from "../services/conditions-service";

const AntTab = styled((props) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    textTransform: "none",
    minWidth: 0,
    [theme.breakpoints.up("sm")]: {
      minWidth: 0,
    },
    marginRight: theme.spacing(1),
    color: "#0365C0",
    fontWeight: 400,
    fontSize: "16px",
    backgroundColor: "#FFFFFF",
    fontFamily: ["Roboto"].join(","),
    "&:hover": {
      color: "#0839AD",
      opacity: 1,
    },
    "&.Mui-selected": {
      color: "#000000",
      fontWeight: theme.typography.fontWeightBold,
    },
    "&.Mui-focusVisible": {
      backgroundColor: "#000000",
    },
  })
);

const ErrorMessage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [formatTab, setFormatTab] = useState("1");
  const [show, setShow] = useState(false);
  const [ignoreOBXInTransactionShow, setIgnoreOBXInTransactionShow] =
    useState(false);
  const [form, setForm] = useState({});
  const [showUpdateWarningModal, setShowUpdateWarningModal] = useState(false);
  const [showRemoveWarningModal, setShowRemoveWarningModal] = useState(false);
  const [isUpdated, setIsUpdated] = useState(false);
  const [isUpdateError, setIsUpdateError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [alertMessage, setAlertMessage] = useState();
  const [hl7SegmentValues, setHl7SegmentValues] = useState([]);
  const [jsonMessage, setJsonMessage] = useState(null);
  const [conditions, setConditions] = useState([]);
  const [showUpdateIgnoreWarningModal, setShowUpdateIgnoreWarningModal] =
    useState(false);

  const handleFormatTabChange = (event, newValue) => {
    setFormatTab(newValue);
  };

  const [isError, setIsError] = useState(
    location?.state?.isAdded != null ? !location?.state?.isAdded : false
  );
  const [isAdded, setIsAdded] = useState(
    location?.state?.isAdded != null ? location?.state?.isAdded : false
  );

  const [validated, setValidated] = useState(false);
  const [validatedIgnoreOBX, setValidatedIgnoreOBX] = useState(false);
  const [transactionRecord, setTransactionRecord] = useState({});
  const [HL7Message, setHL7Message] = useState("");
  const [duplicateRecord, setDuplicateRecord] = useState(null);

  const [user] = useContext(UserContext);
  const [ignoreValues, setIgnoreValues] = useState(null);
  const [ignoredCheckedValues, setIgnoredCheckedValues] = useState([]);

  const getTransactionById = async () => {
    let transactionId = location.state.transactionId;
    let response = await fetchTransactionById(transactionId);

    if (response.ok) {
      let data = await response.json();
      setTransactionRecord(data);
    } else {
      setIsError(true);
      let error = await response.json();
      setAlertMessage(error?.description);
    }
  };

  const getTransactionHL7 = async () => {
    let transactionId = location.state.transactionId;
    let response = await fetchTransactionHL7(transactionId);

    if (response.ok) {
      let data = await response.text();
      let newData = "Raw Message\n\n" + data;
      setHL7Message(newData);
    } else {
      setIsError(true);
      let error = await response.json();
      setAlertMessage(error?.description);
    }
  };

  const getTransactionJson = async () => {
    let transactionId = location.state.transactionId;
    let response = await fetchTransactionJSON(transactionId);

    if (response.ok) {
      let data = await response.json();
      setJsonMessage(data);
    } else {
      // setIsError(true);
      // let error = await response.text();
      // setJsonMessage(error?.description);
    }
  };

  const getConditions = async () => {
    let response = await fetchConditions();
    if (response.ok) {
      let data = await response.json();
      if (data?.length > 0) {
        setConditions(data);
      } else {
        // setAlertMessage(data?.description);
      }
    } else {
      let error = await response.json();
      // setAlertMessage(error?.description);
    }
  };

  const getDuplicateRecordInfo = async () => {
    let transactionId = location.state.transactionId;
    let response = await fetchDuplicateTransaction(transactionId);

    if (response.ok) {
      let data = await response.json();
      let newData = data?.transactionId + " (" + data?.hl7RawMsg + ")";
      setDuplicateRecord(newData);
    } else {
      setIsError(true);
      let error = await response.json();
      setAlertMessage(error?.description);
    }
  };

  const updateTransaction = async () => {
    let user = JSON.parse(Cookies.get("userInfoFromOkta"));

    let newForm = {
      ...form,
      transactionId: location?.state?.transactionId.toString(),
      name: user?.name,
      userName: user?.preferred_username,
    };
    let response = await updateTransactionRecord(newForm);
    if (response.ok) setIsUpdated(true);
    else {
      let errorMessage = await response.text();
      setIsUpdateError(true);
      setAlertMessage(errorMessage);
    }
  };

  const removeTransaction = async () => {
    let response = await removeTransactionRecord(
      transactionRecord.transactionId
    );
    if (response !== ERROR_MSG) {
      navigate(
        location.state.isMasterQueue 
          ? "/masterQueue" : 
          transactionRecord.sendingFacility !== null
            ? "/errorMessageQueue"
            :"/unknownFacilities",
        {
          state: {
            isDeleted: true,
            filter: location?.state?.filter,
            pageNo: location?.state?.pageNo,
          },
        }
      );
    } else {
      navigate(
        location.state.isMasterQueue 
          ? "/masterQueue" : 
          transactionRecord.sendingFacility !== null
            ? "/errorMessageQueue"
            :"/unknownFacilities",
        {
          state: {
            isDeleted: false,
            filter: location?.state?.filter,
            pageNo: location?.state?.pageNo,
          },
        }
      );
    }
    handleRemoveWarningModalClose();
  };

  const reprocessTransaction = async () => {
    setIsLoading(true);
    let response;
    if (location?.state?.isEICRErrorMessageQueue) {
      response = await reprocessBulkEicrTransactionRecord({
        transId: [transactionRecord.transactionId],
      });
    } else if (location?.state?.isTransactionErrorTable || location.state.isMasterQueue) {
      response = await reprocessBulkTransactionRecord({
        transId: [transactionRecord.transactionId],
      });
    }

    if (response?.responsecode === "0") {
      navigate(
        location.state.isMasterQueue 
          ? "/masterQueue" : 
          transactionRecord.sendingFacility !== null
            ? "/errorMessageQueue"
            :"/unknownFacilities",
        {
          state: {
            isReprocess: true,
            filter: location?.state?.filter,
            pageNo: location?.state?.pageNo,
          },
        }
      );
    } else if (response?.responsecode === "1") {
      navigate(
        location.state.isMasterQueue 
          ? "/masterQueue" : 
          transactionRecord.sendingFacility !== null
            ? "/errorMessageQueue"
            :"/unknownFacilities",

        {
          state: {
            isReprocessWithErrors: true,
            filter: location?.state?.filter,
            pageNo: location?.state?.pageNo,
          },
        }
      );
    } else {
      navigate(
        location.state.isMasterQueue 
          ? "/masterQueue" : 
          transactionRecord.sendingFacility !== null
            ? "/errorMessageQueue"
            :"/unknownFacilities",
        {
          state: {
            isReprocess: false,
            filter: location?.state?.filter,
            pageNo: location?.state?.pageNo,
          },
        }
      );
    }
  };

  const handleCheckboxChange = (
    newValue,
    checkedValues,
    setCheckedValues,
    filter
  ) => {
    let copyCheckedValues = [...checkedValues];

    if (copyCheckedValues.includes(newValue)) {
      copyCheckedValues = copyCheckedValues.filter((item) => item !== newValue);
    } else {
      copyCheckedValues = [...copyCheckedValues, newValue];
    }
    setCheckedValues(copyCheckedValues);
  };

  const getSegmentDataAndValues = async () => {
    let response = await fetchCodeSetTable("HL7 Segments");
    if (response.ok) {
      let data = await response.json();
      setHl7SegmentValues(data.refTableValues);
    } else {
      let error = await response.json();
      setAlertMessage(error?.description);
    }
  };

  const handleRemoveWarningModalClose = () => setShowRemoveWarningModal(false);
  const handleUpdateIgnoreWarningModalClose = () =>
    setShowUpdateIgnoreWarningModal(false);
  const handleUpdateWarningModalClose = () => setShowUpdateWarningModal(false);

  const handleUpdateIgnore = (event) => {
    setShowUpdateIgnoreWarningModal(true);
  };
  const handleIndexChange = (value) => {
    const onlydigitsValue = value.replace(/[^0-9]/g, "");
    setField("index", onlydigitsValue);
  };

  const handleOBRIndexChange = (value) => {
    const onlydigitsValue = value.replace(/[^0-9]/g, "");
    setField("obrIndex", onlydigitsValue);
  };

  const getFieldOptions = (condition) => {
    const filteredHl7SegmentValues = hl7SegmentValues.filter(
      (item) => item.reference_Code_system === condition
    );
    const fields = filteredHl7SegmentValues.reduce((code, description) => {
      code[description.reference_code] = description.reference_Code_description;
      return code;
    }, {});
    return Object.entries(fields);
  };

  const setField = (field, value) => {
    setForm({
      ...form,
      [field]: value,
    });
  };

  const handleClose = () => setShow(false);
  const handleIgnoreOBXClose = () => setIgnoreOBXInTransactionShow(false);

  const handleUpdate = () => {
    getSegmentDataAndValues();
    setForm({});
    setIsUpdated(false);
    setIsUpdateError(false);
    setIsAdded(false);
    setIsError(false);
    setValidated(false);
    setShow(true);
  };

  const handleReprocess = () => {
    setForm({});
    setIsUpdated(false);
    setIsUpdateError(false);
    setIsAdded(false);
    setIsError(false);
    reprocessTransaction();
  };

  const handleIgnoreOBX = () => {
    setForm({});
    setIsUpdated(false);
    setIsUpdateError(false);
    setIsAdded(false);
    setIsError(false);
    setValidatedIgnoreOBX(false);
    setIgnoreOBXInTransactionShow(true);
  };

  const handleRemove = () => {
    setShowRemoveWarningModal(true);
    setIsUpdated(false);
    setIsUpdateError(false);
    setIsAdded(false);
    setIsError(false);
  };

  const handleSubmmit = (event) => {
    event.preventDefault();
    setValidated(true);
    if (event.currentTarget.checkValidity() === true) {
      setShow(false);
      setShowUpdateWarningModal(true);
    }
  };

  const handleIgnoreOBXSubmit = async (event) => {
    event.preventDefault();
    setValidatedIgnoreOBX(true);
    if (event.currentTarget.checkValidity() === true) {
      const response = await updateTransactionFields({
        ...transactionRecord,
        ignoreFields: ignoredCheckedValues.join("&"),
      });
      if (response.ok === true) setIsUpdated(true);
      else {
        setIsUpdateError(true);
        setAlertMessage(ERROR_MSG);
        if (transactionRecord?.ignoreFields != null)
          setIgnoredCheckedValues(transactionRecord?.ignoreFields?.split(","));
      }
      setIgnoreOBXInTransactionShow(false);
    }
    setShowUpdateIgnoreWarningModal(false);
  };

  const handleAddRule = () => {
    navigate("/rulesScreen", {
      state: {
        landingTab: "2",
        from: "errorMessage",
        transactionId: location?.state?.transactionId,
      },
    });
  };

  const hasAccessToDiscardButton = () => {
    if (
      componentIsVisible(UFDDB, user) &&
      location?.state?.isUnknownFacilityTable
    ) {
      return true;
    } else if (
      componentIsVisible(EMDDB, user) &&
      (location?.state?.isTransactionErrorTable
      ||
      location?.state?.isMasterQueue)
    ) {
      return true;
    }
    return false;
  };

  const buttonsLayout = () => {
    return (
      <>
        {!location?.state?.isDiscardQueueTable &&
          !location?.state?.isEicrDiscardQueueTable && (
            <div className="flexCenter">
              <img
                src={`${validateAndSanitizeUrl(S3_URL)}update-icon.png`}
                className="buttonIconNoMarR"
                alt=""
              ></img>
              <Button
                className="updateButtonStyle generalFont flexCenter"
                onClick={handleUpdate}
              >
                Update
              </Button>
              <img
                src={`${validateAndSanitizeUrl(S3_URL)}reprocess-icon.png`}
                className="buttonIconNoMarR"
                alt=""
              ></img>
              <Button
                className="updateButtonStyle generalFont flexCenter"
                onClick={handleReprocess}
              >
                Reprocess
              </Button>
              {hasAccessToDiscardButton() && (
                <>
                  <img
                    src={`${validateAndSanitizeUrl(S3_URL)}delete-icon.png`}
                    className="buttonIconNoMarR"
                    alt=""
                  ></img>
                  <Button
                    className="removeButtonStyle generalFont flexCenter"
                    onClick={handleRemove}
                  >
                    Discard
                  </Button>
                </>
              )}

              {(location?.state?.isUnknownFacilityTable ||
                location?.state?.isTransactionErrorTable ||
                location?.state?.isDiscardQueueTable ||
                location?.state?.isMasterQueue
              ) && (
                <Button
                  className="updateButtonStyle generalFont flexCenter"
                  onClick={handleIgnoreOBX}
                >
                  Ignore OBX(s)
                </Button>
              )}
            </div>
          )}
      </>
    );
  };

  const handleUpdateTransaction = async () => {
    updateTransaction();
    setShowUpdateWarningModal(false);
  };

  const renderBannerMessage = () => {
    if (isAdded) {
      return "Successfully added new Rule";
    } else if (isUpdated) {
      return "Message was successfully updated";
    } else if (isError || isUpdateError) {
      return alertMessage
        ? alertMessage
        : "Something went wrong, please try again";
    }
  };

  const getAllOBROBXfromJSON = async () => {
    setIgnoreValues(
      jsonMessage?.PATIENTRESULTGROUP[0]?.ZRI.map((item) => ({
        ...item,
        key: `OBR${item.OBR}->OBX${item.OBX}`,
        isEditableCondition: item.Condition === "",
      }))
    );
  };

  useEffect(() => {
    getConditions();
    if (location?.state?.transactionId != null) {
      getTransactionById();
	  // getTransactionHL7 is deferred to the transactionRecord effect to avoid a race condition
      jsonMessage === null && getTransactionJson();
      location?.state?.isDuplicateQueue && getDuplicateRecordInfo();
    }
  }, []);

  useEffect(() => {
    console.log(transactionRecord)
    if (Object.keys(transactionRecord).length !== 0) {
      if (transactionRecord?.ignoreFields != null)
        setIgnoredCheckedValues(transactionRecord?.ignoreFields?.split(","));
	  // VXU transactions have no HL7 file; skip fetch (and its error banner) when path is absent
      if (transactionRecord?.hl7RawMsg) {
        getTransactionHL7();
      }
    }
  }, [transactionRecord]);

  useEffect(() => {
    if (jsonMessage != null) {
      getAllOBROBXfromJSON();
    }
  }, [jsonMessage]);

  function identifyTable(
    isMasterQueue,
    isEicrMasterQueue,
    isDuplicateQueue,
    isUnknownFacilityTable,
    isTransactionErrorTable,
    isDiscardQueueTable,
    isEicrDiscardQueueTable,
    isEICRErrorMessageQueue
  ) {
    if (isDiscardQueueTable) return "/discardQueue";
    if (isEicrDiscardQueueTable) return "/eicrDiscardQueue";
    if (isTransactionErrorTable) return "/errorMessageQueue";
    if (isUnknownFacilityTable) return "/unknownFacilities";
    if (isDuplicateQueue) return "/duplicateMessageQueue";
    if (isEICRErrorMessageQueue) return "/eicrErrorMessageQueue";
    if (isMasterQueue) return "/masterQueue";
    if (isEicrMasterQueue) return "/eicrMasterQueue";
    return "/";
  }

  const handleBackRouteMessage = () => {
    const toString = identifyTable(
      location?.state?.isMasterQueue,
      location?.state?.isEicrMasterQueue,
      location?.state?.isDuplicateQueue,
      location?.state?.isUnknownFacilityTable,
      location?.state?.isTransactionErrorTable,
      location?.state?.isDiscardQueueTable,
      location?.state?.isEicrDiscardQueueTable,
      location?.state?.isEICRErrorMessageQueue
    );
    return (
      <Link
        to={toString}
        className="linkStyle"
        state={{
          filter: location?.state?.filter,
          pageNo: location?.state?.pageNo,
        }}
      >
        Back to Table
      </Link>
    );
  };

  return (
    <>
      <Container fluid className="errorMessageContainer">
        {isLoading && <FullScreenSpinner />}
        <Row>
          <Col>
            <Row className="tableTitle generalFont">Message Details</Row>

            <Row className="tableSubtitle generalFont" style={{ width: "95%" }}>
              <Col style={{ display: "flex", justifyContent: "end" }}>
                {handleBackRouteMessage()}
              </Col>
            </Row>
          </Col>
        </Row>
        <Row style={{ width: "97%" }}>
          {(isAdded || isError) && (
            <Alert
              key={"success"}
              variant={isError ? "danger" : "success"}
              onClose={() => {
                setIsAdded(false);
                setIsError(false);
              }}
              dismissible
            >
              {renderBannerMessage()}
            </Alert>
          )}
        </Row>

        <Row
          className="summaryContainer"
          style={{ display: "flex", paddingBottom: "15px" }}
        >
          <Row style={{ marginTop: "20px" }}>
            <Col sm={3} className="summaryColStylePaddL">
              <span className="textSmallFontBig generalFont">Identifier</span>
              <span className="textSmallFontSm generalFont">
                {transactionRecord?.transactionId
                  ? transactionRecord?.transactionId
                  : "-"}
              </span>
            </Col>
            <Col sm={3} className="summaryColStyle">
              <span className="textSmallFontBig generalFont">Name</span>
              <span className="textSmallFontSm generalFont">
                {transactionRecord?.patient?.fname &&
                transactionRecord?.patient?.lname
                  ? `${transactionRecord.patient.fname} ${transactionRecord.patient.lname}`
                  : "-"}
              </span>
            </Col>
            <Col sm={3} className="summaryColStyle">
              <span className="textSmallFontBig generalFont">
                Sending Facility
              </span>
              <span className="textSmallFontSm generalFont">
                {transactionRecord.sendingFacilityName != null
                  ? transactionRecord.sendingFacilityName
                  : "-"}
              </span>
            </Col>
            <Col sm={3} className="summaryColStyle">
              {!location?.state?.isEicrMasterQueue &&
              !location?.state?.isEicrDiscardQueueTable &&
              !location?.state?.isEICRErrorMessageQueue &&
              !transactionRecord?.msh12 === "eICR" ? (
                <>
                  <span className="textSmallFontBig generalFont">CLIA</span>
                  <span className="textSmallFontSm generalFont">
                    {transactionRecord?.sendingFacility?.clia != null
                      ? transactionRecord.sendingFacility.clia
                      : transactionRecord?.npi != null
                      ? transactionRecord?.npi
                      : "-"}
                  </span>
                </>
              ) : (
                <>
                  <span className="textSmallFontBig generalFont">
                    Sending Facility ID{" "}
                  </span>
                  <span className="textSmallFontSm generalFont">
                    {transactionRecord?.npi != null
                      ? transactionRecord?.npi
                      : transactionRecord?.sendingFacility?.clia != null
                      ? transactionRecord.sendingFacility.clia
                      : "-"}
                  </span>
                </>
              )}
            </Col>
          </Row>
          <Row style={{ marginTop: "20px" }}>
            <Col sm={3} className="summaryColStylePaddL">
              <span className="textSmallFontBig generalFont">
                Time Received
              </span>
              <span className="textSmallFontSm generalFont">
                {transactionRecord.transactionReceivedDate != null
                  ? moment(transactionRecord.transactionReceivedDate).format(
                      "MM/DD/YYYY HH:mm"
                    )
                  : "-"}
              </span>
            </Col>
            {location?.state?.isMasterQueue &&
              location?.state?.isEicrMasterQueue && (
                <Col sm={3} className="summaryColStyle">
                  <span className="textSmallFontBig generalFont">
                    Time Processed
                  </span>
                  <span className="textSmallFontSm generalFont">
                    {transactionRecord.updatedDate != null
                      ? moment(transactionRecord.updatedDate).format(
                          "MM/DD/YYYY HH:mm"
                        )
                      : "-"}
                  </span>
                </Col>
              )}
            <Col sm={3} className={"summaryColStyle"}>
              <span className="textSmallFontBig generalFont">
                Message Control ID
              </span>
              <span className="textSmallFontSm generalFont">
                {transactionRecord.msh10 ? transactionRecord.msh10 : "-"}
              </span>
            </Col>
            {!location?.state?.isEicrMasterQueue &&
              !location?.state?.isEicrDiscardQueueTable &&
              !location?.state?.isEICRErrorMessageQueue && (
                <Col sm={3} className="summaryColStyle">
                  <span className="textSmallFontBig generalFont">
                    Specimen ID
                  </span>
                  <span className="textSmallFontSm generalFont">
                    {transactionRecord.specimen != null
                      ? transactionRecord.specimen
                      : "-"}
                  </span>
                </Col>
              )}
          </Row>
          <Row style={{ marginTop: "20px" }}>
            <Col className="summaryColStylePaddL">
              <span className="textSmallFontBig generalFont">File Name</span>
              <span
                className="textSmallFontSm generalFont"
                style={{ maxWidth: "95%" }}
              >
                {location?.state?.isEicrMasterQueue ||
                location?.state?.isEicrDiscardQueueTable ||
                location?.state?.isEICRErrorMessageQueue ||
                transactionRecord?.msh12 === "eICR"
                  ? transactionRecord.jsonPayload
                  : transactionRecord.hl7RawMsg != null
                  ? transactionRecord.hl7RawMsg.substring(
                      transactionRecord.hl7RawMsg.indexOf("/") + 1
                    )
                  : "-"}
              </span>
            </Col>
          </Row>
          {location?.state?.isDuplicateQueue && duplicateRecord != null && (
            <Row style={{ marginTop: "20px" }}>
              <Col className="summaryColStylePaddL">
                <span className="textSmallFontBig generalFont">
                  Matching Record - Identifier (File Name)
                </span>
                <span className="textSmallFontSm generalFont">
                  {duplicateRecord}
                </span>
              </Col>
            </Row>
          )}
        </Row>

        <Row style={{ marginRight: "54px", marginTop: "40px" }}>
          <Box
            sx={{
              width: "100%",
              typography: "body1",
              paddingLeft: "0px",
              paddingRight: "0px",
            }}
          >
            <TabContext sx={{ height: "38px" }} value={formatTab}>
              <TabList
                onChange={handleFormatTabChange}
                aria-label="Format Tabs"
              >
                <AntTab label="HL7" value="1" />
                <AntTab label="JSON" value="2" />
                <AntTab label="QA Flags" value="3" />
              </TabList>
              <TabPanel className="noPaddMarginTop40" value="1">
                <Form.Control
                  as="textarea"
                  className="tabTxtArea"
                  disabled
                  readOnly
                  value={
                    HL7Message
                      ? HL7Message
                      : "No HL7 message found at the source location."
                  }
                  wrap="off"
                  rows={
                    HL7Message.split("\r").length +
                    HL7Message.split("\n").length
                  }
                />
                {
                  !location?.state?.isEicrMasterQueue &&
                  !location?.state?.isDuplicateQueue &&
                  (transactionRecord?.status==="ERROR" ||  transactionRecord?.status==="EXCEPTION") && (
                    <Row className="errorTxtContainer generalFont ">
                      Error Breakdown
                    </Row>
                  )}
                {(isUpdated || isUpdateError) && (
                  <Alert
                    key={"success"}
                    variant={isUpdateError ? "danger" : "success"}
                    onClose={() => {
                      setIsUpdated(false);
                      setIsUpdateError(false);
                    }}
                    dismissible
                  >
                    {renderBannerMessage()}
                  </Alert>
                )}
                {!location?.state?.isEicrMasterQueue &&
                  !location?.state?.isDuplicateQueue && 
                  (transactionRecord?.status==="ERROR" ||  transactionRecord?.status==="EXCEPTION") && (
                    <IDSTable
                      buttonsLayout={buttonsLayout}
                      isErrorScreen={true}
                      headCells={errorMessageHeadCells}
                      rows={transactionRecord?.transactionError?.map(
                        (item) => ({
                          errorCode: item?.errorCode,
                          errorType: item?.errorRef?.errorDisplayName,
                          errorPath: item?.errorPath,
                          errorDescription: item?.errorRef?.errorDescription,
                          errorComments: item?.errorComments,
                        })
                      )}
                      addButtonName="Add New Rule"
                      addButtonAction={handleAddRule}
                      noButtons={
                        location?.state?.isEICRErrorMessageQueue ||
                        location?.state?.isEicrDiscardQueueTable ||
                        location?.state?.isDiscardQueueTable
                      }
                    />
                  )}
              </TabPanel>
              <TabPanel className="noPaddMarginTop40" value="2">
                <>
                  <ErrorMessageJSONTab />
                </>
              </TabPanel>
              <TabPanel className="noPaddMarginTop40" value="3">
                <ErrorMessageQAFlags
                  transactionId={location.state.transactionId}
                />
              </TabPanel>
            </TabContext>
          </Box>
        </Row>
      </Container>

       <Modal
        show={showRemoveWarningModal}
        onHide={handleRemoveWarningModalClose}
        size="lg"
        centered
      >
        <Modal.Header className="modalHeaderContainer" closeButton>
          <Modal.Title className="modalHeader generalFont">
            Remove Transaction Message
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="modalBodyContainer">
          <React.Fragment>
            <Form.Label className="modalLabel generalFont">
              Are you sure you want to remove this Transaction Message from the
              Table?
            </Form.Label>
          </React.Fragment>
        </Modal.Body>
        <Modal.Footer className="modalFooterContainer">
          <Button
            onClick={handleRemoveWarningModalClose}
            className="modalCancelStyle generalFont flexCenter"
            variant="secondary"
          >
            Cancel
          </Button>
          <Button
            onClick={removeTransaction}
            className="modalRemoveStyle generalFont flexCenter"
          >
            Remove
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showUpdateIgnoreWarningModal}
        onHide={handleUpdateIgnoreWarningModalClose}
        size="lg"
        centered
        autoFocus
        enforceFocus
      >
        <Modal.Header className="modalHeaderContainer" closeButton>
          <Modal.Title className="modalHeader generalFont">
            Update & Ignore OBX's in the Message!
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="modalBodyContainer">
          <React.Fragment>
            <Form.Label className="modalLabel generalFont">
              WARNING: the following condition selection can't be undone.
            </Form.Label>
            <Form.Label className="modalLabel generalFont">
              Are you sure you want to Update & Ignore OBX's in the Message from
              the Table?
            </Form.Label>
          </React.Fragment>
        </Modal.Body>
        <Modal.Footer className="modalFooterContainer">
          <Button
            onClick={handleUpdateIgnoreWarningModalClose}
            className="modalCancelStyle generalFont flexCenter"
            variant="secondary"
          >
            Cancel
          </Button>
          <Button
            onClick={handleIgnoreOBXSubmit}
            className="modalRemoveStyle generalFont flexCenter"
          >
            Update & Ignore
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={ignoreOBXInTransactionShow}
        onHide={handleIgnoreOBXClose}
        size="lg"
        centered
        dialogClassName="my-modal-50"
        autoFocus
        enforceFocus
      >
        <Modal.Header className="modalHeaderContainer" closeButton>
          <Modal.Title className="modalHeader generalFont">
            Which OBX's to ignore?
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="modalBodyContainer">
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow style={{ backgroundColor: "#f5f5f5", height: 40 }}>
                  <TableCell sx={{ fontWeight: "bold" }}></TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>OBR:OBX</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Loinc</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Snomed</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>
                    Measured Result
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Result</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Condition</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {ignoreValues?.map((row, index) => (
                  <TableRow key={row.key} style={{ height: 40 }}>
                    <TableCell>
                      <Checkbox
                        checked={ignoredCheckedValues?.includes(
                          row.key + "~" + row.Condition
                        )}
                        onChange={() => {
                          handleCheckboxChange(
                            row.key + "~" + row.Condition,
                            ignoredCheckedValues,
                            setIgnoredCheckedValues
                          );
                          if (row.isEditableCondition) {
                            let copyRows = [...ignoreValues];
                            let X = copyRows[index];
                            X["Condition"] = "";
                            setIgnoreValues(copyRows);
                          }
                        }}
                        name={row.key}
                      />
                    </TableCell>
                    <TableCell>{row.key}</TableCell>
                    <TableCell>{row.LoincCode ? row.LoincCode : "-"}</TableCell>
                    <TableCell>
                      {row.SnomedCode ? row.SnomedCode : "-"}
                    </TableCell>
                    <TableCell>
                      {row.ObsValueAsRatio ? row.ObsValueAsRatio : "-"}
                    </TableCell>
                    <TableCell>{row.Result ? row.Result : "-"}</TableCell>
                    <TableCell>
                      {row.isEditableCondition || row.Condition === "" ? (
                        <Form.Select
                          className="modalInput generalFont"
                          style={{ width: "200px" }}
                          aria-label="Choose Item"
                          value={row.Condition}
                          onChange={(e) => {
                            let copyCheckedValues = [...ignoredCheckedValues];
                            const keyToUpdate = row.key + "~";
                            const valueToUpdate = e.target.value;
                            const existingIndex = copyCheckedValues.findIndex(
                              (item) => item.startsWith(keyToUpdate)
                            );

                            if (existingIndex !== -1) {
                              copyCheckedValues[existingIndex] =
                                keyToUpdate + valueToUpdate;
                            } else {
                              copyCheckedValues = [
                                ...copyCheckedValues,
                                keyToUpdate + valueToUpdate,
                              ];
                            }
                            setIgnoredCheckedValues(copyCheckedValues);

                            let copyRows = [...ignoreValues];
                            let X = copyRows[index];
                            X["Condition"] = e.target.value;
                            setIgnoreValues(copyRows);
                          }}
                          feedback="You must agree before submitting."
                        >
                          <option value="">Choose Item</option>
                          {_.sortBy(conditions, ["conditionName"]).map(
                            (entry) => {
                              return (
                                <option
                                  key={entry.conditionId}
                                  value={entry.conditionName}
                                  name={entry.conditionName}
                                >
                                  {entry.conditionName}
                                </option>
                              );
                            }
                          )}
                        </Form.Select>
                      ) : (
                        row.Condition
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Modal.Body>
        <Modal.Footer className="modalFooterContainer">
          {/* <Button
              type="submit"
              className="modalAddUpdateStyle generalFont flexCenter"
            >
              Update & Ignore
            </Button> */}
          <Button
            style={{ marginTop: "40px" }}
            onClick={handleIgnoreOBXClose}
            className="modalCancelStyle generalFont flexCenter"
            variant="secondary"
          >
            Cancel
          </Button>{" "}
          <Button
            style={{ marginTop: "40px" }}
            onClick={handleUpdateIgnore}
            className="modalAddUpdateStyle generalFont flexCenter"
            variant="secondary"
          >
            Update & Ignore
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={show} onHide={handleClose} size="lg" centered>
        <Form onSubmit={handleSubmmit} noValidate validated={validated}>
          <Modal.Header className="modalHeaderContainer" closeButton>
            <Modal.Title className="modalHeader generalFont">
              Update Message
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="modalBodyContainer">
            <Form.Group className="mb-3">
              <Row>
                <Col>
                  <Form.Group className="mb-3" controlId="segment">
                    <Form.Label className="modalLabel generalFont">
                      Segment
                    </Form.Label>
                    <Form.Select
                      className="modalInput generalFont"
                      aria-label="Choose Item"
                      value={form.segment}
                      required
                      onChange={(e) => {
                        const { value } = e.target;
                        setForm((prevForm) => ({
                          ...prevForm,
                          segment: value,
                          dataElement: "",
                          index: "",
                          value: "",
                        }));
                      }}
                    >
                      <option hidden value="">
                        Choose Item
                      </option>
                      <option value="MSH">MSH</option>
                      <option value="PID">PID</option>
                      <option value="ORC">ORC</option>
                      <option value="OBR">OBR</option>
                      <option value="OBX">OBX</option>
                      <option value="SPM">SPM</option>
                      <option value="ZZZ">ZZZ</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              <Row style={{ marginTop: "30px" }}>
                <Col>
                  <Form.Group className="mb-3" controlId="dataElement">
                    <Form.Label className="modalLabel generalFont">
                      Data Element
                    </Form.Label>
                    <Form.Select
                      required
                      className="modalInput generalFont"
                      aria-label="Choose Item"
                      value={form.dataElement}
                      disabled={form.segment == null || form.segment === ""}
                      onChange={(e) => {
                        const { value } = e.target;
                        setForm((prevForm) => ({
                          ...prevForm,
                          dataElement: value,
                          index: "",
                          value: "",
                        }));
                      }}
                    >
                      <option hidden value="">
                        Choose Item
                      </option>
                      {getFieldOptions(form.segment).map(([key, val]) => {
                        return (
                          <option key={key} value={key}>
                            {val}
                          </option>
                        );
                      })}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              {form?.segment === "OBX" && (
                <Row style={{ marginTop: "30px" }}>
                  <Col>
                    <Form.Group className="mb-3" controlId="value">
                      <Form.Label className="modalLabel generalFont">
                        OBR Index
                      </Form.Label>
                      <Form.Control
                        className="modalInput generalFont"
                        maxLength={3}
                        placeholder="Enter Value (Max 3 digits)"
                        value={form.obrIndex}
                        onChange={(e) => handleOBRIndexChange(e.target.value)}
                        feedback="Max 3 digits are allowed"
                      />
                    </Form.Group>
                  </Col>
                </Row>
              )}

              <Row style={{ marginTop: "30px" }}>
                <Col>
                  <Form.Group className="mb-3" controlId="value">
                    <Form.Label className="modalLabel generalFont">
                      Index
                    </Form.Label>
                    <Form.Control
                      className="modalInput generalFont"
                      maxLength={3}
                      placeholder="Enter Value (Max 3 digits)"
                      value={form.index}
                      onChange={(e) => handleIndexChange(e.target.value)}
                      feedback="Max 3 digits are allowed"
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row style={{ marginTop: "30px" }}>
                <Col>
                  <Form.Group className="mb-3" controlId="value">
                    <Form.Label className="modalLabel generalFont">
                      Value
                    </Form.Label>
                    {form?.dataElement === "OBX2" ? (
                      <Form.Select
                        className="modalInput generalFont"
                        aria-label="Choose Item"
                        required
                        value={form.value}
                        onChange={(e) => setField("value", e.target.value)}
                        feedback="You must select before Applying."
                      >
                        <option value="">Choose Item</option>
                        <option value="ST">ST</option>
                        <option value="CWE">CWE</option>
                        <option value="NM">NM</option>
                        <option value="SN">SN</option>
                      </Form.Select>
                    ) : (
                      <Form.Control
                        className="modalInput generalFont"
                        type="text"
                        placeholder="Hint Text"
                        required
                        value={form.value}
                        onChange={(e) => setField("value", e.target.value)}
                      />
                    )}
                  </Form.Group>
                </Col>
              </Row>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer className="modalFooterContainer">
            <Button
              type="submit"
              className="modalAddUpdateStyle generalFont flexCenter"
            >
              Apply
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      <Modal
        show={showUpdateWarningModal}
        onHide={handleUpdateWarningModalClose}
        size="lg"
        centered
      >
        <Modal.Header className="modalHeaderContainer" closeButton>
          <Modal.Title className="modalHeader generalFont">
            Update Message
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          className="modalBodyContainer"
          style={{
            backgroundColor: "#F8DFE2",
            marginRight: "40px",
            marginLeft: "40px",
            marginTop: "40px",
          }}
        >
          <Form.Label className="modalLabel generalFont">
            <div>
              <img
                src={`${validateAndSanitizeUrl(S3_URL)}warning-icon.png`}
                style={{
                  width: "21px",
                  height: "18.5px",
                  marginRight: "25px",
                }}
                alt=""
              ></img>
              <label>Are you sure you want to update the message?</label>
            </div>
          </Form.Label>
        </Modal.Body>
        <Modal.Footer className="modalFooterContainer">
          <Button
            style={{ marginTop: "40px" }}
            onClick={handleUpdateTransaction}
            className="modalAddUpdateStyle generalFont flexCenter"
            variant="secondary"
          >
            Apply
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ErrorMessage;
